import React, { PropsWithChildren } from "react";
import { useTheme } from "styled-components";

import { FOOTER } from "@config/testIds/footer";

import { AVAILABLE_COUNTRIES } from "@typings/globals";

import { Dropdown } from "@components/Navigation/Dropdown";

import { EarthHomeWorld } from "@ui/Assets/MyIcons/EarthHomeWorld";

import { DrawerManager } from "@features/DrawerManager/DrawerManager.www";

import { getCountriesList } from "@services/Localisation";

import { useTranslate } from "@hooks/useTranslate";
import { useBreakpoint } from "@hooks/useBreakpoint";

import * as Styled from "./CountrySelector.styled";

const CountySelectorDrawerId = "country-selector-drawer";

export const CountrySelector: React.FC<
  PropsWithChildren<{ country: AVAILABLE_COUNTRIES }>
> = ({ children, country }) => {
  const [isDropdownActive, setIsDropdownActive] = React.useState(false);
  const translate = useTranslate();
  const theme = useTheme();
  const countries = getCountriesList(translate);
  const { showDrawer } = DrawerManager.useManager();
  const { mobile, largeMobile } = useBreakpoint();
  const currentCountry = countries.find(i => i.value === country);

  const isMobile = mobile || largeMobile;

  return (
    <Styled.Root>
      <Dropdown
        hoverColor="blue50"
        testIds={{
          button: FOOTER.COUNTRY_SELECT_TRIGGER,
          panel: FOOTER.COUNTRY_SELECT_DROPDOWN,
        }}
        eventId="countrySelectDropdown"
        label={
          <Styled.CustomLabel>
            <EarthHomeWorld width={theme.icons.sizes.base_x3} />
            <span>
              {isMobile
                ? currentCountry?.value?.toUpperCase()
                : currentCountry?.label}
            </span>
          </Styled.CustomLabel>
        }
        position="right"
        distance={14}
        zIndex={1}
        isActive={isDropdownActive}
        setIsActive={show => {
          if (isMobile) {
            show && showDrawer(CountySelectorDrawerId);
          } else {
            setIsDropdownActive(show);
          }
        }}
      >
        {children}
      </Dropdown>
      <DrawerManager variant="cross" id={CountySelectorDrawerId}>
        {children}
      </DrawerManager>
    </Styled.Root>
  );
};
